var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useFunctionClient } from '@juvare/platform-sdk-react/ui/hooks';
import useSWR from 'swr';
/**
 * Calls a platform function and returns an SWR response.
 * SWR `revalidateOnFocus` option is set to `false`.
 *
 * @param functionName - name of the platform function that is to be executed
 * @param params - platform function parameters
 * @param baseUrl - optional base URL
 * @param tokenProvider - optional token provider
 * @param config - custom SWR configuration
 */
export function usePlatformFunction(functionName, params, baseUrl, tokenProvider, config) {
    const functionClient = useFunctionClient(baseUrl, tokenProvider);
    return useSWR(params ? [`/platform/function`, params] : null, (_a) => __awaiter(this, [_a], void 0, function* ([, request]) {
        return request
            ? functionClient.executeFunction({ functionName: functionName, params: Object.assign({}, params) })
            : undefined;
    }), config !== null && config !== void 0 ? config : {
        revalidateOnFocus: false,
    });
}
